import * as columnConstants from '../dataTable/constants'
import * as dbConstants from '../../dao/dbConstants'
import { getPublishingStatusLabel, getPlatformLabel } from '../../utils/platformConstants'
import { getContentStatusLabel, resolveContentStatus } from '../../utils/contentStatusUtils'
import { getFirmAccountTypeLabel } from '../../utils/firmAccountTypeConstants'

const TIMESTAMP_WIDTH = '245px'
const DATE_FORMAT = 'LL/dd/yyyy';
const TIMESTAMP_FORMAT = 'LL/dd/yyyy hh:mm:ss a';

const getSubArray = (array, indices) => {
  return indices.map(index => array[index]);
}

const getOrderByObject = (fieldName, sortDirection=columnConstants.SORT_DIRECTION_ASCENDNG) => {
  return {orderBy: fieldName, sortDirection: sortDirection}
}

const getCoulmnVisibilityObject = (columns, isVisible=true, isSpecialColumnVisible=false, isCheckboxColumnVisible=false, isRowActionsColumnVisible=true) => {
  return columns.reduce((obj, column) => {
    obj[column.value] = isVisible;
    return obj
  }, {
    [columnConstants.SPECIAL_COLUMN_NOTIFICATION]: isSpecialColumnVisible,
    [columnConstants.SPECIAL_COLUMN_CHECKBOX]: isCheckboxColumnVisible,
    [columnConstants.SPECIAL_COLUMN_ROWACTIONS]: isRowActionsColumnVisible
  });
}

const articleAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Type', value: 'articleTypeLabel', isSortable: true},
  {label: 'Source', value: 'source', isSortable: true},
  {label: 'Status', value: 'status', isSortable: true},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];
const articleDisplayColumns = getSubArray(articleAllColumns, [0, 1, 2, 3, 6]);
const articleColumnVisibility = getCoulmnVisibilityObject(articleAllColumns)
const articleDefaultSortBy = getOrderByObject('name');

const campaignAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Company', value: 'companyName', isSortable: true},
  {label: 'Product', value: 'productName', isSortable: true},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true}
];
const campaignDisplayColumns = getSubArray(campaignAllColumns, [0, 1, 2, 5]);
const campaignColumnVisibility = getCoulmnVisibilityObject(campaignAllColumns)
const campaignDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);

const companyAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Type', value: 'companyTypeName', isSortable: true, style:{whiteSpace: 'nowrap'}},
  {label: 'Website', value: 'website', isSortable: true},
  {label: 'Description', value: 'description', isSortable: true, headerStyle:{whiteSpace: 'nowrap'}},
  {label: 'Writing Style', value: 'writingStyleName', isSortable: true, headerStyle:{whiteSpace: 'nowrap'}},
  {label: 'Created By', value: 'createdByName', isSortable: true, headerStyle:{whiteSpace: 'nowrap'}},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{minWidth: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{minWidth: TIMESTAMP_WIDTH}, isSortable: true, headerStyle:{whiteSpace: 'nowrap'}}
];
const companyDisplayColumns = getSubArray(companyAllColumns, [0, 1, 3, 7]);
const companyColumnVisibility = getCoulmnVisibilityObject(companyAllColumns)
const companyDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);

const contentAllColumns = [
  {label: 'Name', value: 'title', isSortable: true, isLinkedToEditScreen: true},
  {
    label: 'Status',
    value: 'status',
    isSortable: true,
    valueFunction: (_value, row) => {
      const resolvedStatus = resolveContentStatus(row.status, row.isPublished);
      const label = getContentStatusLabel(resolvedStatus);
      const statusClass = resolvedStatus.toLowerCase().replace(/_/g, '-');
      return (
        <span className={`content-status-badge status-${statusClass}`}>
          <span>{label}</span>
        </span>
      );
    }
  },
  {label: 'Content Type', value: 'contentTypeName', isSortable: true},
  {label: 'Campaign', value: 'campaignName', isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Writing Style', value: 'writingStyleName', isSortable: true},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];
const contentDisplayColumns = getSubArray(contentAllColumns, [0, 1, 2, 3, 4]);
const contentColumnVisibility = getCoulmnVisibilityObject(contentAllColumns)
const contentDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);

const firmAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Id', value: 'id', isSortable: true},
  {label: 'Signup Date', value: 'signupDate', dataType: columnConstants.DATATYPE_DATE, format: DATE_FORMAT, isSortable: true},
  {label: 'Default Language', value: 'defaultLanguage', isSortable: true},
  {label: 'Timezone', value: 'timezone', isSortable: true},
  {label: 'Date Format', value: 'dateFormat', isSortable: true},
  {label: 'Status', value: 'status', isSortable: true},
  {label: 'Firm Type', value: 'accountType', isSortable: true, valueFunction: (value) => getFirmAccountTypeLabel(value)},
  {label: 'Phone', value: 'phone', isSortable: true},
  {label: 'Bill Limit', value: 'aiCostLimit', isSortable: true},
  {label: 'Customer ID', value: 'paymentCustomerId', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Primary User', value: 'primaryUserName', isSortable: true},
  {label: 'Primary User Email', value: 'primaryUserEmail', isSortable: true}
];

const firmDisplayColumns = getSubArray(firmAllColumns, [0, 13, 14, 1, 7, 4, 5, 6, 10, 2]);
const firmColumnVisibility = getCoulmnVisibilityObject(firmAllColumns)
const firmDefaultSortBy = getOrderByObject('name', columnConstants.SORT_DIRECTION_ASCENDNG);

const billingAllColumns = [
  {label: 'Id', value: 'id', isSortable: true},
  {label: 'Metric Type', value: 'metricType', isSortable: true},
  {label: 'Screen', value: 'entityName', isSortable: true},
  {label: 'Operation', value: 'screenName', isSortable: true},
  {label: 'Cost ($)', value: 'cost', isSortable: true},
  {label: 'Timestamp', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'User ID', value: 'userId', isSortable: true},
  {label: 'User', value: 'userName', isSortable: true},
  {label: 'Customer', value: 'firmName', isSortable: true},
  {label: 'Service', value: 'billableServiceName', isSortable: true},
];

const billingDisplayColumns = getSubArray(billingAllColumns, [5, 9, 8, 10, 1, 2, 3, 4]);
const billingDefaultSortBy = getOrderByObject('createdOn', columnConstants.SORT_DIRECTION_DESCENDING);
const billingColumnVisibility = getCoulmnVisibilityObject(billingAllColumns);

const personaAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true}
];
const personaDisplayColumns = getSubArray(personaAllColumns, [0, 1, 2, 3]);
const personaColumnVisibility = getCoulmnVisibilityObject(personaAllColumns)
const personaDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);

const productAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Type', value: 'productTypeName', isSortable: true},
  {label: 'Company', value: 'companyName', isSortable: true},
  {label: 'Website', value: 'website', isSortable: true},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true}
];
const productDisplayColumns = getSubArray(productAllColumns, [0, 1, 2, 6]);
const productColumnVisibility = getCoulmnVisibilityObject(productAllColumns)
const productDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);

const sourceContentAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Topic', value: 'topicName', isSortable: false},
  {label: 'Campaign', value: 'campaignName', isSortable: true},
  {label: 'Company', value: 'companyName', isSortable: true},
  {label: 'Product', value: 'productName', isSortable: true},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true}
]
const sourceContentDisplayColumns = getSubArray(sourceContentAllColumns, [0, 1, 3, 4, 7]);
const sourceContentColumnVisibility = getCoulmnVisibilityObject(sourceContentAllColumns)
const sourceContentDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);

const topicAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Level', value: 'level', isSortable: true},
  {label: 'Category Name', value: 'parentName', isSortable: true},
  {label: 'Active', value: 'isActive', isSortable: true, dataType: columnConstants.DATATYPE_BOOLEAN_YES_NO},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true}
];
const topicDisplayColumns = getSubArray(topicAllColumns, [0, 1, 2, 3, 5]);
const topicColumnVisibility = getCoulmnVisibilityObject(topicAllColumns)
const topicDefaultSortBy = getOrderByObject('name');

const userAllColumns = [
  {label: 'First Name', value: 'firstName', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Last Name', value: 'lastName', isSortable: true},
  {label: 'Middle Name', value: 'middleName', isSortable: true},
  {label: 'Email', value: 'email', isSortable: true},
  {label: 'Home Phone', value: 'homePhone', isSortable: true},
  {label: 'Cell Phone', value: 'cellPhone', isSortable: true},
  {label: 'Last Login', value: 'lastSuccessfulLogin', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Failed Login Attempts', value: 'failedLoginAttempts', dataType: columnConstants.DATATYPE_INTEGER, isSortable: true},
  {label: 'Last Login Attempt', value: 'lastLoginAttempt', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'External Id', value: 'externalId', isSortable: true},
  {label: 'Active?', value: 'isActive', valueFunction: (value) => (value === true ? 'Active' : 'Inactive'), isSortable: true, dataType: columnConstants.DATATYPE_BOOLEAN_YES_NO},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Locked Out Until', value: 'lockoutUntil', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];


const userDisplayColumns = getSubArray(userAllColumns, [0, 1, 3, 10]);
const userColumnVisibility = getCoulmnVisibilityObject(userAllColumns)
const userDefaultSortBy = getOrderByObject('firstName');

const writingStyleAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Type', value: 'type', isSortable: true},
  {label: 'Source', value: 'documentSrc', isSortable: true},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true}
]
const writingStyleDisplayColumns = getSubArray(writingStyleAllColumns, [0, 1, 3, 5])
const writingStyleColumnVisibility = getCoulmnVisibilityObject(writingStyleAllColumns)
const writingStyleDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);

const roleAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Description', value: 'description', isSortable: true},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true}
]

const roleDisplayColumns = getSubArray(roleAllColumns, [0, 1])
const roleColumnVisibility = getCoulmnVisibilityObject(roleAllColumns)
const roleDefaultSortBy = getOrderByObject('name');

const linkAllColumns = [
  {label: 'Title', value: 'title', isSortable: true},
  {label: 'URL', value: 'url', isSortable: true},
  {label: 'Description', value: 'description', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];
const linkDisplayColumns = getSubArray(linkAllColumns, [0, 1, 2]);
const linkColumnVisibility = getCoulmnVisibilityObject(linkAllColumns);
const linkDefaultSortBy = getOrderByObject('title');

const testimonialAllColumns = [
  {label: 'Title', value: 'title', isSortable: true},
  {label: 'Rating', value: 'rating', isSortable: true},
  {label: 'Type', value: 'type', isSortable: true},
  {label: 'Publish Date', value: 'publishDate', dataType: columnConstants.DATATYPE_DATE, format: DATE_FORMAT, isSortable: true},
  {label: 'Review Text', value: 'text', isSortable: false},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Location', value: 'locationName', isSortable: true},
];
const testimonialDisplayColumns = getSubArray(testimonialAllColumns, [3, 0, 6, 1, 2]);
const testimonialColumnVisibility = getCoulmnVisibilityObject(testimonialAllColumns);
const testimonialDefaultSortBy = getOrderByObject('publishDate', columnConstants.SORT_DIRECTION_DESCENDING);

const publishAllColumns = [
  {label: 'Title', value: 'title', isSortable: true},
  {label: 'Platform', value: 'platformId', isSortable: true, valueFunction: (value) => getPlatformLabel(value)},
  {label: 'Status', value: 'status', isSortable: true, valueFunction: (value) => getPublishingStatusLabel(value)},
  {label: 'Content Title', value: 'contentTitle', isSortable: true},
  {label: 'Publish Date', value: 'publishDate', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Publish URL', value: 'publishUrl', isSortable: false},
  {label: 'Published By', value: 'publishedBy', isSortable: true, valueFunction: (value, row) => {
    if (row.createdByFirstName && row.createdByLastName) {
      return `${row.createdByFirstName} ${row.createdByLastName}`;
    }
    return 'Unknown';
  }},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true}
]
const publishDisplayColumns = getSubArray(publishAllColumns, [0, 1, 2, 4, 6])
const publishColumnVisibility = getCoulmnVisibilityObject(publishAllColumns)
const publishDefaultSortBy = getOrderByObject('publishDate', columnConstants.SORT_DIRECTION_DESCENDING);

const promptTemplateAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Category', value: 'category', isSortable: true},
  {label: 'Vertical', value: 'masterCompanyTypeId', isSortable: false,
    valueFunction: (value) => (value ? `Vertical #${value}` : 'Base')
  },
  {label: 'Intent', value: 'intent', isSortable: false,
    valueFunction: (value) => value || 'Base'
  },
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];
const promptTemplateDisplayColumns = getSubArray(promptTemplateAllColumns, [0, 1, 2, 3, 4]);
const promptTemplateColumnVisibility = getCoulmnVisibilityObject(promptTemplateAllColumns);
const promptTemplateDefaultSortBy = getOrderByObject('name');

const instructionBlockAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Scope', value: 'scope', isSortable: true,
    valueFunction: (value) => {
      const labels = { common: 'Common', vertical: 'Vertical', intent: 'Intent' };
      return labels[value] || value;
    }
  },
  {label: 'Content Type', value: 'contentTypeKey', isSortable: false,
    valueFunction: (value) => value || 'All'
  },
  {label: 'Sort Order', value: 'sortOrder', isSortable: true},
  {label: 'Active', value: 'isActive', isSortable: false,
    valueFunction: (value) => (value ? 'Yes' : 'No')
  },
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];
const instructionBlockDisplayColumns = getSubArray(instructionBlockAllColumns, [0, 1, 2, 3, 4, 5]);
const instructionBlockColumnVisibility = getCoulmnVisibilityObject(instructionBlockAllColumns);
const instructionBlockDefaultSortBy = getOrderByObject('sortOrder');

const supportRequestAllColumns = [
  {label: 'ID', value: 'id', isSortable: true},
  {label: 'User', value: 'userName', isSortable: true},
  {label: 'Email', value: 'userEmail', isSortable: true},
  {label: 'Firm', value: 'firmName', isSortable: true},
  {label: 'Question', value: 'triggerQuestion', isSortable: false},
  {label: 'Type', value: 'triggerType', isSortable: true,
    valueFunction: (value) => value === 'user_requested' ? 'User Requested' : 'Low Confidence'
  },
  {label: 'Status', value: 'status', isSortable: true,
    valueFunction: (value) => {
      const labels = { pending: 'Pending', in_progress: 'In Progress', resolved: 'Resolved', closed: 'Closed' };
      return labels[value] || value;
    }
  },
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];
const supportRequestDisplayColumns = getSubArray(supportRequestAllColumns, [1, 3, 4, 6, 7]);
const supportRequestColumnVisibility = getCoulmnVisibilityObject(supportRequestAllColumns);
const supportRequestDefaultSortBy = getOrderByObject('createdOn', columnConstants.SORT_DIRECTION_DESCENDING);

const backofficeUserAllColumns = [
  {label: 'First Name', value: 'firstName', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Last Name', value: 'lastName', isSortable: true},
  {label: 'Email', value: 'email', isSortable: true},
  {label: 'Active?', value: 'isActive', isSortable: true, dataType: columnConstants.DATATYPE_BOOLEAN_YES_NO, valueFunction: (value) => (value === true ? 'Active' : 'Inactive')},
  {label: 'Last Login', value: 'lastSuccessfulLogin', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];
const backofficeUserDisplayColumns = getSubArray(backofficeUserAllColumns, [0, 1, 2, 3, 4]);
const backofficeUserColumnVisibility = getCoulmnVisibilityObject(backofficeUserAllColumns);
const backofficeUserDefaultSortBy = getOrderByObject('firstName');

const contentValidatorAllColumns = [
  {label: 'Name', value: 'name', isSortable: true, isLinkedToEditScreen: true},
  {label: 'Description', value: 'description', isSortable: true},
  {label: 'Provider', value: 'provider', isSortable: true},
  {label: 'Model', value: 'model', isSortable: true},
  {label: 'Active', value: 'isActive', isSortable: true, dataType: columnConstants.DATATYPE_BOOLEAN_YES_NO},
  {label: 'Created By', value: 'createdByName', isSortable: true},
  {label: 'Created', value: 'createdOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
  {label: 'Last Updated', value: 'updatedOn', dataType: columnConstants.DATATYPE_DATETIME, format: TIMESTAMP_FORMAT, style:{width: TIMESTAMP_WIDTH}, isSortable: true},
];
const contentValidatorDisplayColumns = getSubArray(contentValidatorAllColumns, [0, 1, 2, 3, 4]);
const contentValidatorColumnVisibility = getCoulmnVisibilityObject(contentValidatorAllColumns);
const contentValidatorDefaultSortBy = getOrderByObject('name');

const displayColumns = {
  [dbConstants.ENTITY_NAME_ARTICLE]: articleDisplayColumns,
  [dbConstants.ENTITY_NAME_CAMPAIGN]: campaignDisplayColumns,
  [dbConstants.ENTITY_NAME_COMPANY]: companyDisplayColumns,
  [dbConstants.ENTITY_NAME_PRODUCT]: productDisplayColumns,
  [dbConstants.ENTITY_NAME_PERSONA]: personaDisplayColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM]: firmDisplayColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS]: billingDisplayColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: promptTemplateDisplayColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: instructionBlockDisplayColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: supportRequestDisplayColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_USER]: backofficeUserDisplayColumns,
  [dbConstants.ENTITY_NAME_CONTENT]: contentDisplayColumns,
  [dbConstants.ENTITY_NAME_SOURCE_CONTENT]: sourceContentDisplayColumns,
  [dbConstants.ENTITY_NAME_USER]: userDisplayColumns,
  [dbConstants.ENTITY_NAME_WRITING_STYLE]: writingStyleDisplayColumns,
  [dbConstants.ENTITY_NAME_TOPIC]: topicDisplayColumns,
  [dbConstants.ENTITY_NAME_ROLE]: roleDisplayColumns,
  [dbConstants.ENTITY_NAME_PUBLISH]: publishDisplayColumns,
  [dbConstants.ENTITY_NAME_LINK]: linkDisplayColumns,
  [dbConstants.ENTITY_NAME_TESTIMONIAL]: testimonialDisplayColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR]: contentValidatorDisplayColumns,
}

const allColumns = {
  [dbConstants.ENTITY_NAME_ARTICLE]: articleAllColumns,
  [dbConstants.ENTITY_NAME_CAMPAIGN]: campaignAllColumns,
  [dbConstants.ENTITY_NAME_COMPANY]: companyAllColumns,
  [dbConstants.ENTITY_NAME_PRODUCT]: productAllColumns,
  [dbConstants.ENTITY_NAME_PERSONA]: personaAllColumns,
  [dbConstants.ENTITY_NAME_CONTENT]: contentAllColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM]: firmAllColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS]: billingAllColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: promptTemplateAllColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: instructionBlockAllColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: supportRequestAllColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_USER]: backofficeUserAllColumns,
  [dbConstants.ENTITY_NAME_SOURCE_CONTENT]: sourceContentAllColumns,
  [dbConstants.ENTITY_NAME_USER]: userAllColumns,
  [dbConstants.ENTITY_NAME_WRITING_STYLE]: writingStyleAllColumns,
  [dbConstants.ENTITY_NAME_TOPIC]: topicAllColumns,
  [dbConstants.ENTITY_NAME_ROLE]: roleAllColumns,
  [dbConstants.ENTITY_NAME_PUBLISH]: publishAllColumns,
  [dbConstants.ENTITY_NAME_LINK]: linkAllColumns,
  [dbConstants.ENTITY_NAME_TESTIMONIAL]: testimonialAllColumns,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR]: contentValidatorAllColumns,
}

const defaultSortBy = {
  [dbConstants.ENTITY_NAME_ARTICLE]: articleDefaultSortBy,
  [dbConstants.ENTITY_NAME_CAMPAIGN]: campaignDefaultSortBy,
  [dbConstants.ENTITY_NAME_COMPANY]: companyDefaultSortBy,
  [dbConstants.ENTITY_NAME_PRODUCT]: productDefaultSortBy,
  [dbConstants.ENTITY_NAME_PERSONA]: personaDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM]: firmDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS]: billingDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: promptTemplateDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: instructionBlockDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: supportRequestDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_USER]: backofficeUserDefaultSortBy,
  [dbConstants.ENTITY_NAME_CONTENT]: contentDefaultSortBy,
  [dbConstants.ENTITY_NAME_SOURCE_CONTENT]: sourceContentDefaultSortBy,
  [dbConstants.ENTITY_NAME_USER]: userDefaultSortBy,
  [dbConstants.ENTITY_NAME_WRITING_STYLE]: writingStyleDefaultSortBy,
  [dbConstants.ENTITY_NAME_TOPIC]: topicDefaultSortBy,
  [dbConstants.ENTITY_NAME_ROLE]: roleDefaultSortBy,
  [dbConstants.ENTITY_NAME_PUBLISH]: publishDefaultSortBy,
  [dbConstants.ENTITY_NAME_LINK]: linkDefaultSortBy,
  [dbConstants.ENTITY_NAME_TESTIMONIAL]: testimonialDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR]: contentValidatorDefaultSortBy,
}


const columnVisibility = {
  [dbConstants.ENTITY_NAME_ARTICLE]: articleColumnVisibility,
  [dbConstants.ENTITY_NAME_CAMPAIGN]: campaignColumnVisibility,
  [dbConstants.ENTITY_NAME_COMPANY]: companyColumnVisibility,
  [dbConstants.ENTITY_NAME_PRODUCT]: productColumnVisibility,
  [dbConstants.ENTITY_NAME_PERSONA]: personaColumnVisibility,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM]: firmColumnVisibility,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS]: billingColumnVisibility,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: promptTemplateColumnVisibility,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: instructionBlockColumnVisibility,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: supportRequestColumnVisibility,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_USER]: backofficeUserColumnVisibility,
  [dbConstants.ENTITY_NAME_CONTENT]: contentColumnVisibility,
  [dbConstants.ENTITY_NAME_SOURCE_CONTENT]: sourceContentColumnVisibility,
  [dbConstants.ENTITY_NAME_USER]: userColumnVisibility,
  [dbConstants.ENTITY_NAME_WRITING_STYLE]: writingStyleColumnVisibility,
  [dbConstants.ENTITY_NAME_TOPIC]: topicColumnVisibility,
  [dbConstants.ENTITY_NAME_ROLE]: roleColumnVisibility,
  [dbConstants.ENTITY_NAME_PUBLISH]: publishColumnVisibility,
  [dbConstants.ENTITY_NAME_LINK]: linkColumnVisibility,
  [dbConstants.ENTITY_NAME_TESTIMONIAL]: testimonialColumnVisibility,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR]: contentValidatorColumnVisibility,
}

export const getAllColumns = (entityName) => {
  return allColumns[entityName]
}

const getDisplayColumnsLSKey = (userId, entityName) => {

  return `${userId}_${entityName}_DisplayColumns`;
}

export const getDisplayColumns = (userId, entityName) => {
  const displayColumnsLSKey = getDisplayColumnsLSKey(userId, entityName)
  let entityDisplayColumns = localStorage.getItem(displayColumnsLSKey)
  if (entityDisplayColumns) {
    entityDisplayColumns = JSON.parse(entityDisplayColumns)
  }
  else {
    entityDisplayColumns = displayColumns[entityName]
  }
  return sanitizeDisplayColumns(entityDisplayColumns, getAllColumns(entityName));
}

export const saveDisplayColumns = (userId, entityName, columns) => {
  const displayColumnsLSKey = getDisplayColumnsLSKey(userId, entityName)
  localStorage.setItem(displayColumnsLSKey, JSON.stringify(columns));
}

export const resetDisplayColumns = (userId, entityName) => {
  localStorage.removeItem(getDisplayColumnsLSKey(userId, entityName));
}

export const getColumnVisibility = (entityName) => {
  return columnVisibility[entityName]
}

export const getDefaultOrderBy = (entityName) => {
  return defaultSortBy[entityName]
}

const sanitizeDisplayColumns = (selectedDisplayColumns, allDisplayColumns) => {
  console.log('Sanitizing display columns', selectedDisplayColumns, allDisplayColumns);
  let allDisplayColumnsMap = {};
  allDisplayColumns.forEach((column, index) => {
    allDisplayColumnsMap[column.value] = index;
  });

  let sanitizedList = [];
  selectedDisplayColumns.forEach((column) => {
    if (!column || !column.value) {
      return;
    }
    if(typeof allDisplayColumnsMap[column.value] === 'number') {
      sanitizedList.push(allDisplayColumns[allDisplayColumnsMap[column.value]]);
    }
  });
  return sanitizedList;
}